/* ================================================================
   ALTAIR · Cadeau automatique (Schutzhülle) — page /cart uniquement
   ----------------------------------------------------------------
   Le tiroir maison (lume-cart-drawer.js) n'est PAS chargé sur /cart
   — cf. layout/theme.liquid : {% if template != 'cart' %} — alors que
   c'est lui qui synchronise le cadeau. Ce script rejoue donc la même
   règle sur la page panier, avec la même clé sessionStorage pour que
   les deux restent d'accord :

     · 1 Schutzhülle offerte par valise présente au panier
     · quantité figée (les boutons +/- de la ligne cadeau sont masqués)
     · image + titre non cliquables (pas de page produit dédiée)
     · suppression possible, et mémorisée pour la session tant qu'il
       reste au moins une valise (vider les valises réarme l'offre)
   ================================================================ */
(function () {
  if (window.__AltairGiftSync) return;
  window.__AltairGiftSync = true;

  var GIFT_PRODUCT_ID = 15760044818758;   // Schutzhülle
  var GIFT_VARIANT_ID = 57512201388358;   // Default Title — 0,00 €
  var SUITCASE_PRODUCT_IDS = [
    15760044687686,  // Altair Original Cabin
    15760044753222,  // Altair Original Cabin - Secret
    15796486472006   // Altair Trunk
  ];
  var SUITCASE_TYPES = ['koffer'];
  var OPTOUT_KEY = 'altair:gift-optout';

  function optedOut() {
    try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try {
      if (v) sessionStorage.setItem(OPTOUT_KEY, '1');
      else   sessionStorage.removeItem(OPTOUT_KEY);
    } catch (e) {}
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }

  function isGift(it) {
    return it.variant_id === GIFT_VARIANT_ID || it.product_id === GIFT_PRODUCT_ID;
  }
  function isSuitcase(it) {
    if (SUITCASE_PRODUCT_IDS.indexOf(it.product_id) !== -1) return true;
    return SUITCASE_TYPES.indexOf(String(it.product_type || '').toLowerCase()) !== -1;
  }

  /* Réconcilie la ligne cadeau. Résout true si le panier a été modifié. */
  function sync() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return false;
        var suitcases = 0;
        var gift = null;
        (cart.items || []).forEach(function (it) {
          if (isGift(it)) { gift = it; return; }
          if (isSuitcase(it)) suitcases += (it.quantity || 0);
        });

        // Plus aucune valise : on retire le cadeau et on réarme l'offre.
        if (suitcases <= 0) {
          setOptOut(false);
          if (gift) return post('/cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return true; });
          return false;
        }
        // Le client a supprimé le cadeau : on respecte son choix.
        if (optedOut()) {
          if (gift) return post('/cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return true; });
          return false;
        }
        if (!gift) {
          return post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: suitcases }] })
            .then(function () { return true; });
        }
        if (gift.quantity !== suitcases) {
          return post('/cart/change.js', { id: gift.key, quantity: suitcases }).then(function () { return true; });
        }
        return false;
      })
      .catch(function () { return false; });
  }

  /* Neutralise la ligne cadeau rendue par snippets/cart-item.liquid.
     Point d'accroche stable : l'input de quantité porte data-quantity-variant-id. */
  function lockGiftRow() {
    var input = document.querySelector('input[data-quantity-variant-id="' + GIFT_VARIANT_ID + '"]');
    if (!input) return;
    var row = input.closest('li.cart-item') || input.closest('.cart-item') || input.closest('li');
    if (!row || row.classList.contains('altair-gift-row')) return;
    row.classList.add('altair-gift-row');

    if (!document.getElementById('altair-gift-row-css')) {
      var st = document.createElement('style');
      st.id = 'altair-gift-row-css';
      st.textContent =
        '.altair-gift-row .wt-cart__item__link{pointer-events:none!important;cursor:default!important;}' +
        '.altair-gift-row quantity-counter .js-counter-button{display:none!important;}' +
        '.altair-gift-row .js-counter-quantity{pointer-events:none!important;text-align:center;}';
      document.head.appendChild(st);
    }

    // Si le client supprime le cadeau, on ne le lui remet pas.
    row.querySelectorAll('cart-remove-button').forEach(function (btn) {
      btn.addEventListener('click', function () { setOptOut(true); }, true);
    });
  }

  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      sync().then(function (changed) {
        if (changed) window.location.reload();
        else lockGiftRow();
      });
    }, 400);
  }

  function boot() {
    lockGiftRow();
    sync().then(function (changed) {
      if (changed) { window.location.reload(); return; }
      lockGiftRow();
      // Le thème re-rend les lignes après chaque update : on resynchronise.
      var host = document.getElementById('main-cart-items');
      if (!host) return;
      try {
        new MutationObserver(function () { lockGiftRow(); scheduleSync(); })
          .observe(host, { childList: true, subtree: true });
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
